import { render } from "./TimerComponent.vue?vue&type=template&id=29b88fbb"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__